import { Icon } from '@iconify/react'
import React, { useContext } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { submitReport } from '../../utils/platform'
import { AuthContext } from '../Auth/AuthProvider'

export default function FeedbackButton() {
  const { t } = useTranslation()
  const [showModal, setShowModal] = React.useState(false)
  const [reportText, setReportText] = React.useState('')
  const { auth, userInfo } = useContext(AuthContext)
  const isHappyExpert = window.location.origin.includes('happyexperts')

  const handleReportButtonClick = () => setShowModal(true)

  const handleReportTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) =>
    setReportText(e.target.value)

  const handleClose = () => {
    setShowModal(false)
    setReportText('')
  }

  const handleSubmitReport = async () => {
    try {
      await submitReport(
        auth?.token,
        userInfo?.stsUserId,
        userInfo?.caiInstance?.chatId,
        reportText,
      )

      toast.success(
        t('notification.sendReportSuccess', 'Report is sent successfully'),
      )
      handleClose()
    } catch (error) {
      toast.error(t('common.toast.error'))
    }
  }

  return (
    <>
      <Button
        className="d-flex align-items-cente px-3 py-2 mb-2"
        style={{ cursor: 'pointer' }}
        onClick={handleReportButtonClick}
      >
        <div className="d-flex gap-2">
          <Icon
            height="24"
            icon="material-symbols-light:feedback-outline-rounded"
            width="24"
          />
          <span style={{ color: 'var(--color-on-primary)' }}>
            {t('common.word.feedback')}
          </span>
        </div>
      </Button>
      {showModal && (
        <Modal show={showModal} onHide={handleClose}>
          <Modal.Header>
            <Modal.Title>
              {t(
                'resources.feedbacks.modal.title',
                'Your Feedback is important',
              )}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>{t('resources.feedbacks.modal.description')}</p>

            <textarea
              className="form-control"
              rows={5}
              value={reportText}
              onChange={handleReportTextChange}
            />
          </Modal.Body>

          <Modal.Footer>
            <button className="btn btn-secondary" onClick={handleClose}>
              {t('common.button.cancel', 'Cancel')}
            </button>

            <button
              className="btn btn-primary"
              disabled={!reportText.trim()}
              onClick={handleSubmitReport}
            >
              {t('common.button.send')}
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  )
}
